import { defineMessages } from "react-intl";

export const columnsMessages = defineMessages({
  categoryName: {
    id: 'vEYtiq',
    defaultMessage: "Category Name",
  },
  subcategories: {
    defaultMessage: "Subcategories",
    id: "F7DxHw",
  },
  numberOfProducts: {
    defaultMessage: "Number of Products",
    id: 'DFq7Rg',
  },
});

export const messages = defineMessages({
  noData: {
    defaultMessage: "No categories found",
    id: "dM86a2",
  },
});
